export default __webpack_public_path__ + "static/media/ic_clock_sm.83bdc704.svg";